export default "__VITE_ASSET__NH_TCgs4__"